<template>
  <div class="toolbar-layout">
    <div @click="$emit('on-menu-click')">
      <b-icon icon="menu" size="is-medium"></b-icon>
    </div>
    <img class="toolbar-layout__image" src="@/assets/img/png/nav-logo.png" />
    <img
      class="toolbar-layout__avatar"
      :src="doctor.imageProfileUrl"
      height="35"
      @click="$emit('on-avatar-click')"
    />
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import { mapState } from 'vuex'
export default Vue.extend({
  name: 'Toolbar',

  computed: {
    ...mapState('doctor', ['doctor'])
  }
})
</script>

<style lang="sass" scoped>
@import @/assets/sass/style
.toolbar-layout
    display: flex
    justify-content: space-between
    align-items: center
    background: $white
    z-index: 2
    width: 100%
    height: $toolbar-height
    padding: 12px 24px
    box-shadow: 0px 4px 6px 1px $strokes
    position: sticky
    top: 0

    &__image
        height: 40px

    &__avatar
        object-fit: contain
        width: 40px
        padding-right: 8px
        border-radius: 5px
</style>
